import { useDebug } from '@/hooks/useDebug';
import { folder, useControls } from 'leva';
import { lazy, useEffect } from 'react'

// lazy import debugtools -> ensure we never send unecessary stuff to the end user
const ReactQueryDevtools = lazy(() => import("@tanstack/react-query-devtools").then(m => ({ default: m.ReactQueryDevtools,}))); //prettier-ignore
const Leva = lazy(() => import("leva").then((m) => ({ default: m.Leva })));
const LoadingDevtools = lazy(() => import("@/features/loading/components/LoadingDevtools").then((m) => ({ default: m.LoadingDevtools })));

export function Debug() {
    const isDebug = useDebug()
    const [controls] = useControls(() => ({ Debug: folder({ query: false, loadingmanager: false, borders: false }, { collapsed: true })}))

    useEffect(() => {
      const styleId = 'debug-borders-style';
      if (controls.borders) {
        // Create and inject style if it doesn't exist
        if (!document.getElementById(styleId)) {
          const style = document.createElement('style');
          style.id = styleId;
          style.textContent = '* { border: 1px solid red !important; }';
          document.head.appendChild(style);
        }
      } else {
        // Remove style if borders are disabled
        const style = document.getElementById(styleId);
        if (style) style.remove();
      }
    }, [controls.borders]);

return (
    <>
      {isDebug && controls.query && <ReactQueryDevtools />}
      {controls.loadingmanager && <LoadingDevtools />}
      <Leva hidden={!isDebug} />
    </>
  )
}

// lazy import debugtools -> ensure we never send unecessary stuff to the end user
const Perf = lazy(() =>import("r3f-perf").then(m => ({ default: m.Perf }))); //prettier-ignore

export function CanvasDebug() {
  const isDebug = useDebug()
  const [controls] = useControls(() => ({ Performance: folder({ perf: false }, { collapsed: true })}))
  return (
    <>
       {isDebug && controls.perf && <Perf position="top-left" />}
    </>
  )

}
